import React, {useState, useEffect, useContext} from 'react';
import axios from 'axios';
import { Row,  Table } from 'reactstrap';

import { useNavigate,useLocation,Link } from 'react-router-dom';
import { BiEditAlt, BiTrash } from 'react-icons/bi';
import { toast } from 'react-toastify';
import { BiLeftArrowAlt } from 'react-icons/bi';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import useAuth from '../../hooks/useAuth';

const CommunityPortalInfoView = () => {
    const { auth } = useAuth();

    const [modal, openModal] = useState(false);
    const toggle = () => openModal(!modal);
    const [webPortal, setWebPortal] = useState([]);
    const navigate = useNavigate();
       
    const axiosPrivate = useAxiosPrivate();
    const location = useLocation();


    const handleDelete =  async (event, id) => {
        event.preventDefault();
        try {
            const res = await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/community-portal/delete/${id}`,  {
                headers: {
                    'Authorization': 'Bearer ' + auth.accessToken
                }
            });
            const res1 = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/community-portal/find-all`);
            setWebPortal(res1.data);
            toast.success(res.data.message, {
                className: "success-toast",
                autoClose: 3000,
                position: toast.POSITION.BOTTOM_RIGHT
            })
        } catch (error) {
            error.response.data.message ? toast.error(error.response.data.message, {
                className: "error-toast",
                position: toast.POSITION.BOTTOM_RIGHT,
                autoClose: 3000
                }) :  toast.error(error.response.data.error, {
                  className: "error-toast",
                  position: toast.POSITION.BOTTOM_RIGHT,
                  autoClose: 3000
              })
         }
    }
        

    useEffect(() => {
        let isMounted = true;
        const controller = new AbortController();

        const getWbPortalData = async () => {
            try {
                const response = await axiosPrivate.get(`${process.env.REACT_APP_API_BASE_URL}/community-portal/find-all`, {
                    signal: controller.signal
                });
                isMounted && setWebPortal(response.data);
            } catch (error) {
                error.response.data.message ? toast.error(error.response.data.message, {
                    className: "error-toast",
                    position: toast.POSITION.BOTTOM_RIGHT,
                    autoClose: 3000
                    }) :  toast.error(error.response.data.error, {
                      className: "error-toast",
                      position: toast.POSITION.BOTTOM_RIGHT,
                      autoClose: 3000
                })
                navigate('/login', { state: { from: location }, replace: true });
            }
        }

        getWbPortalData();

        return () => {
            isMounted = false;
            controller.abort();
        }
    }, [])


    return (
        <div className="container">
          <Row sm="12">
            <h5 className="sec-header">Community Web Portal Details</h5>
        </Row> 
        <Row>
            <Table responsive hover>
                <thead>
                <tr>
                    <th>#</th>
                    <th>Tagline</th>
                    <th>Description</th>
                    <th>Actions</th>
                </tr>
                </thead>
                <tbody>
                {
                    webPortal.map(webPortal => (
                      <tr key={webPortal.id}>
                            <td>{webPortal.id}</td>
                            <td style={{wordBreak: "break-all"}}>{webPortal.communityTagLine}</td>
                            <td style={{wordBreak: "break-all"}} dangerouslySetInnerHTML={{ __html: webPortal.communityDesc.substring(0, 150)}}></td>
                            
                            <td>
                                <BiEditAlt className="edit_icon icon_hover" onClick={() => navigate(`/community/web-portal/edit/${webPortal.id}`)} size={30}/> 
                                {/* <BiTrash className="delete_icon icon_hover" onClick={(event) => handleDelete(event, webPortal.id)} size={20} />      */}
                            </td>
                    </tr>
                  ))  
                }
                                
                </tbody>
            </Table>
     </Row>
     {/* {
        webPortal && <Row sm="12" className="mt-4 text-center">
          <Link to={"/community/web-portal/add"} className="go_back" >
            <BiLeftArrowAlt size={30} /> Go to Add Service
          </Link>
      </Row> 
         } */}
        </div>
    )
   
}

export default CommunityPortalInfoView;